import React, { useState, useEffect } from "react";
import Axios from "axios";
import "./App.css";
import { gen1Pokemon } from "./constants/pokemonNames";
import PokemonImage from "./components/PokemonImage";
import Streaks from "./components/Streaks";
import GameOverScreen from "./components/GameOverScreen";
import WinnerScreen from "./components/WinnerScreen";
import PokemonNavbar from "./components/PokemonNavbar";
import PokemonInput from "./components/PokemonInput";
import { isNidoranException } from "./pokemonUtils";

function WhosThatPokemon() {
  const [pokemon, setPokemon] = useState<any>({});
  const [isHidden, setIsHidden] = useState(true);
  const [isNextPokemonButtonShowing, setIsNextPokemonButtonShowing] = useState(false);
  const [streakNumber, setStreakNumber] = useState(0);
  const [isGameOver, setIsGameOver] = useState(false);
  const [isWinner, setIsWinner] = useState(false);
  const [pokemonList, setPokemonList] = useState<string[]>([...gen1Pokemon]);
  const [isPokemonDancing, setIsPokemonDancing] = useState(false);
  const [guessText, setGuessText] = useState<string>("");

  useEffect(() => {
    getRandomPokemonData();
  }, []);

  const handleSubmit = (guessText: string) => {
    if (pokemon.name === guessText.toLowerCase() || isNidoranException(pokemon.name, guessText)) {
      setIsHidden(false);
      setStreakNumber(streakNumber + 1);
      setIsNextPokemonButtonShowing(true);
      setIsPokemonDancing(true);
      
      // Check if this was the last pokemon
      if (pokemonList.length === 1) {
        setTimeout(() => {
          setIsWinner(true);
        }, 500);
      } else {
        setTimeout(() => {
          handleNextPokemon();
          setGuessText("");
        }, 500);
      }
    }
    setGuessText(guessText);
  };
  const getRandomPokemonData = async () => {
    const randomIndex = Math.floor(pokemonList.length * Math.random());
    const chosenPokemon = pokemonList[randomIndex].toLowerCase();
    const updatedList = pokemonList.filter((item) => pokemonList[randomIndex] !== item);
    setPokemonList(updatedList);
    const pokeAPIResponse = await Axios.get(`https://pokeapi.co/api/v2/pokemon/${chosenPokemon}`);
    const data = pokeAPIResponse.data;
    setPokemon(data);
  };

  const handlePlayAgain = () => {
    setIsHidden(true);
    setStreakNumber(0);
    setIsNextPokemonButtonShowing(false);
    getRandomPokemonData();
    setIsGameOver(false);
    setPokemonList([...gen1Pokemon]);
  };

  const handleNextPokemon = () => {
    setIsPokemonDancing(false);
    setIsHidden(true);
    getRandomPokemonData();
    setIsNextPokemonButtonShowing(false);
  };

  return (
    <div className="flex flex-col min-h-screen bg-gradient-to-br from-blue-50 via-purple-50 to-pink-50">
      <PokemonNavbar />
      <div className="flex-1 flex items-center justify-center py-8">
        <div className="text-center w-full max-w-4xl px-4">
          {isWinner ? (
            <WinnerScreen />
          ) : (
            <div className="flex flex-col items-center">
              <img
                className="w-3/5 max-w-[400px]"
                src="/assets/portfolio/whos-that-pokemon.png"
                alt="logo"
              />
              {pokemon && (
                <PokemonImage
                  isHidden={isHidden}
                  pokemon={pokemon}
                  isPokemonDancing={isPokemonDancing}
                />
              )}

              {isGameOver ? (
                <GameOverScreen
                  pokemon={pokemon}
                  streakNumber={streakNumber}
                  handlePlayAgain={handlePlayAgain}
                />
              ) : (
                <>
                  <Streaks streakNumber={streakNumber} />
                  <PokemonInput
                    handleSubmit={handleSubmit}
                    isNextPokemonButtonShowing={isNextPokemonButtonShowing}
                    guessText={guessText}
                    setIsGameOver={setIsGameOver}
                  />
                </>
              )}
            </div>
          )}
        </div>
      </div>
      <footer className="py-4 bg-white/50 backdrop-blur-sm border-t border-gray-200">
        <h5 className="text-sm text-gray-500">Pokemon data from PokeAPI</h5>
      </footer>
    </div>
  );
}

export default WhosThatPokemon;
